import { fireLinkTag } from './tagManager';

export default function tagViewMoreViewLessToggle(isOpen: boolean) {
  const eventName = isOpen ? 'product details view more' : 'product details view less';

  fireLinkTag({ event_name: eventName, link_name: eventName });
}
